var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustPerson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 118,
    viewBox: "0 0 118 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "illust/ person"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 114",
    cx: 59.0001,
    cy: 59.0008,
    r: 52.6786,
    fill: "#E8F2FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M58.9492 56.7919C66.2246 56.7919 72.1224 50.894 72.1224 43.6186C72.1224 36.3432 66.2246 30.4453 58.9492 30.4453C51.6738 30.4453 45.7759 36.3432 45.7759 43.6186C45.7759 50.894 51.6738 56.7919 58.9492 56.7919Z",
    fill: "#82AFE7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.8983 60.7441C73.449 60.7441 85.2449 72.5733 85.2449 87.1656C85.2449 87.5976 85.155 88.0118 84.9828 88.408H32.8162C32.6424 88.0117 32.5518 87.5975 32.5518 87.1656C32.5518 72.5733 44.3476 60.7441 58.8983 60.7441Z",
    fill: "#0B3E91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M56.5119 60.8357L56.1167 64.3717L57.3023 65.9433L54.9312 78.5156L58.8831 83.2303L62.8351 78.5156L60.4639 65.9433L61.6495 64.3717L61.2543 60.8357C61.2543 60.8357 59.8989 60.7441 58.8817 60.7441C57.8644 60.7441 56.5119 60.8357 56.5119 60.8357Z",
    fill: "#8BB8F0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustPerson);
export default __webpack_public_path__ + "static/media/illust-person.0d9029414fef270237895029b0ef630b.svg";
export { ForwardRef as ReactComponent };